import { Language } from "../types/language";

export const formatCurrency = (
    lang: Language,
    val: number,
    decimal_point: boolean = false
): string => {
    return new Intl.NumberFormat(`${lang}-CA`, {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: decimal_point ? 2 : 0,
    }).format(val);
};

export const formatDistance = (lang: Language, val: number): string => {
    return new Intl.NumberFormat(`${lang}-CA`, {
        style: "unit",
        //@ts-ignore
        unit: "kilometer",
        unitDisplay: "short",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(val);
};

export const formatPercentage = (
    lang: Language,
    val: number,
    decimal_point: boolean = false
): string => {
    return new Intl.NumberFormat(`${lang}-CA`, {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(!decimal_point ? val / 100 : val);
};

export const capitalizeFirst = (chars: string) =>
    chars.charAt(0).toUpperCase() + chars.slice(1);
